module.exports = __webpack_public_path__ + "img/emblem-white.91d14fb1.svg";